/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

// Shared CSS class tokens used by ForecastLabel and its consumers.
export const SHARED_PREFIX = 'MetricsBlockRow';

export const sharedClasses = {
  forecastIcon: `${SHARED_PREFIX}-forecastIcon`,
};

// Summary grid: two columns (label / value), value right-aligned.
export const SummaryGrid = styled(Box)(({theme}) => ({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  columnGap: theme.spacing(2),
  rowGap: 0,
  alignItems: 'baseline',
}));

// Left column: row label — 14px / 16px regular, onSurfaceLight.
export const RowLabel = styled(Typography)(({theme}) => ({
  fontSize: 14,
  lineHeight: '16px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  whiteSpace: 'nowrap',
}));

// Left column label with the forecast (event_upcoming) icon prefix.
export const ForecastLabel = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: 14,
  lineHeight: '16px',
  fontWeight: 400,
  color: theme.palette.semantic_dark?.surface.onSurfaceLight,
  whiteSpace: 'nowrap',

  [`& .${sharedClasses.forecastIcon}`]: {
    fontSize: 16,
  },
}));

// Right column: value — 14px / 16px medium. Color supplied per-row via the `sx` prop
// (onSurface for plans, good/bad for fact / выполнение / прогноз), so it is NOT fixed here.
export const RowValue = styled(Typography)(() => ({
  fontSize: 14,
  lineHeight: '16px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  justifySelf: 'end',
  textAlign: 'right',
}));

// Right-hand chart area — fills remaining width, stretches to row height.
// overflow: hidden clips the recharts SVG (overflow: visible by default) so a forecast
// line projected below y=0 (yAxisFromZero) doesn't spill past the chart box onto the next card.
export const ChartArea = styled(Box)(() => ({
  flex: '1 0 0',
  minWidth: 0,
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  overflow: 'hidden',
}));
